import { jsVersionWithBuildNumber } from "../global/app";
import { getDeviceType } from "../global/sw-device";
import {
  getChallengeIdsFromUser,
  getConnectedApps,
} from "../global/utils";

import { Capacitor } from "@capacitor/core";
//replace this with something else, since recent workout logs are stored in state, see if we want to still have this
import { WorkoutLog, ActivityKey } from "@sworkit/api";
import {
  saveActivityLog,
} from "../global/firestore-workout-logs";


export const createActivityLog =
  (
    name: string,
    calories: number,
    minutesCompleted: number,
    timestamp: number,
    activityKey: ActivityKey,
    note: string,
    shouldSaveToHealth: boolean,
  ) =>
  async (_dispatch, getState) => {
    const date = new Date(timestamp);
    const createdOn = js_yyyy_mm_dd_hh_mm_ss(date);
    const utcCreated = js_yyyy_mm_dd_hh_mm_ss(createDateAsUTC(date));
    const appVersion = jsVersionWithBuildNumber;
    const deviceType = await getDeviceType();
    const state = getState() as SworkitState;
    const newActivityLog: WorkoutLog = {
      activityKey,
      appVersion,
      platform: Capacitor.getPlatform() as "ios" | "android" | "web",
      calories,
      connectedApps: getConnectedApps(state),
      createdOn,
      heartRate: "",
      slug: null,
      minutesCompleted,
      deviceType,
      name,
      collectionSlug: null,
      timestampMillis: timestamp,
      type: "external-activity",
      utcCreated,
      shouldSaveToHealth,
      savedToHealthIntegrations: [],
      savedToHealth: false,
      category: null,
      logType: "external-activity",
      note: note || null,
      challengeIds: getChallengeIdsFromUser(state.user),
      externalUuid: null,
      assignmentIds: [],
    };
    checkIfLogMeetsAssignment(state.userAssignments, newActivityLog);
    return saveActivityLog(newActivityLog, state.user);
  };

export function checkIfLogMeetsAssignment(
  userAssignmentState: UserAssignmentsState,
  newActivityLog: WorkoutLog,
) {
  newActivityLog.assignmentIds = [];
  const publishedAssignments = getPublishedAssignments(
    userAssignmentState.assignments,
  );
  if (publishedAssignments) {
    const validAssignments = checkAssignmentDate(publishedAssignments);
    validAssignments.forEach((assignment) => {
      if (assignment.workouts.length === 0) {
        newActivityLog.assignmentIds.push(assignment.assignmentId);
      }
    });
  }
}

export function getPublishedAssignments(
  assignments: Assignment[],
): Assignment[] {
  return assignments.filter((assignment) => assignment.status === "published");
}

export function checkAssignmentDate(assignments: Assignment[]): Assignment[] {
  return assignments.filter((assignment) => {
    const d = new Date(assignment.dueDate);
    return d.setDate(d.getDate() + 1) > new Date().getDate() ? true : false;
  });
}

export function createDateAsUTC(now: Date) {
  return new Date(
    now.getUTCFullYear(),
    now.getUTCMonth(),
    now.getUTCDate(),
    now.getUTCHours(),
    now.getUTCMinutes(),
    now.getUTCSeconds(),
  );
}

export function js_yyyy_mm_dd_hh_mm_ss(now: Date) {
  let year = "" + now.getFullYear();
  let month = "" + (now.getMonth() + 1);
  if (month.length == 1) {
    month = "0" + month;
  }
  let day = "" + now.getDate();
  if (day.length == 1) {
    day = "0" + day;
  }
  let hour = "" + now.getHours();
  if (hour.length == 1) {
    hour = "0" + hour;
  }
  let minute = "" + now.getMinutes();
  if (minute.length == 1) {
    minute = "0" + minute;
  }
  let second = "" + now.getSeconds();
  if (second.length == 1) {
    second = "0" + second;
  }
  return (
    year + "-" + month + "-" + day + " " + hour + ":" + minute + ":" + second
  );
}


export const isLogSwApiType = (log: WorkoutLog) =>
  (["studio", "sworkout", "assessment"] as WorkoutLog["logType"][]).includes(
    log.logType,
  );
